/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import {
    CashRegisterDetailsAction,
    CashRegisterDetailsActionType,
    createInitOtpSuccessAction,
    fetchCashRegisterCardDataErrorAction,
    fetchCashRegisterDetailsSuccessAction,
    fetchCashRegisterStatusHistorySuccessAction,
} from 'data/actions/cashRegisterDetailsActions';
import { cashRegistersClient } from 'data/api/cashRegister/cashRegistersClient';

export const fetchCashRegisterDetailsEpic: Epic<CashRegisterDetailsAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashRegisterDetailsActionType.OPEN_REGISTRY_CASH_REGISTER_CARD_PAGE),
        switchMap(() => {
            const factoryNumber = state$.value.routerState.route.params.CashRegisterFactoryNumber;

            return from(cashRegistersClient.fetchCashRegister(factoryNumber)).pipe(
                map((resp) => fetchCashRegisterDetailsSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashRegisterCardDataErrorAction(
                            parseError(
                                err,
                                i18n.t('RegistryScreens.errors.cashRegisterNotFound', {
                                    searchText: factoryNumber,
                                }),
                            ),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(CashRegisterDetailsActionType.EXIT_REGISTRY_CASH_REGISTER_CARD_PAGE))),
            );
        }),
    );
};

export const createInitOtpEpic: Epic<CashRegisterDetailsAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashRegisterDetailsActionType.CREATE_INIT_OTP),
        switchMap(() => {
            const factoryNumber = state$.value.routerState.route.params.CashRegisterFactoryNumber;

            return from(cashRegistersClient.createInitOtp(factoryNumber)).pipe(
                map((resp) => createInitOtpSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashRegisterCardDataErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.createInitOtpFailed')),
                        ),
                    ),
                ),
            );
        }),
    );
};

export const fetchCashRegisterStatusHistoryEpic: Epic<CashRegisterDetailsAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashRegisterDetailsActionType.FETCH_CASH_REGISTER_STATUS_HISTORY),
        switchMap((action) => {
            const factoryNumber = state$.value.routerState.route.params.CashRegisterFactoryNumber;
            const params = action.payload;
            const listName = i18n.t('RegistryScreens.cashRegisterStatusHistory');

            return from(cashRegistersClient.fetchStatusHistory({ factoryNumber, ...params })).pipe(
                map((resp) => fetchCashRegisterStatusHistorySuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchCashRegisterCardDataErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),

                takeUntil(action$.pipe(ofType(CashRegisterDetailsActionType.EXIT_REGISTRY_CASH_REGISTER_CARD_PAGE))),
            );
        }),
    );
};
